/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Col_AssigneeInputs */

const en_tasks_col_assignee = /** @type {(inputs: Tasks_Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

const pt_br2_tasks_col_assignee = /** @type {(inputs: Tasks_Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsável`)
};

/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Tasks_Col_AssigneeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_col_assignee = /** @type {((inputs?: Tasks_Col_AssigneeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Col_AssigneeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_col_assignee(inputs)
	return pt_br2_tasks_col_assignee(inputs)
});